import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../AuthContext';
import { Box, CircularProgress } from '@mui/material';

const ProtectedRoute = () => {
  const { user, isAuthenticated, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // LOGICA CHIAVE: Se l'utente è loggato ma in stato 'pending'
  // E non si trova già sulla pagina per completare il profilo...
  if (user && user.status === 'pending' && location.pathname !== '/completa-profilo') {
    // ...lo reindirizziamo forzatamente lì.
    return <Navigate to="/completa-profilo" replace />;
  }

  // Altrimenti, se è approvato, mostriamo la pagina richiesta.
  return <Outlet />;
};

export default ProtectedRoute;